export enum ChromeMessageType {
	CHECK_STATE = 'CHECK_STATE',
	CONNECT = 'CONNECT',
	DISCONNECT = 'DISCONNECT',
}
